import { render, staticRenderFns } from "./ProcDefNode.vue?vue&type=template&id=a5ac8aba&scoped=true&"
import script from "./ProcDefNode.vue?vue&type=script&lang=js&"
export * from "./ProcDefNode.vue?vue&type=script&lang=js&"
import style0 from "./ProcDefNode.vue?vue&type=style&index=0&id=a5ac8aba&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5ac8aba",
  null
  
)

export default component.exports